/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import GenericChartVisualization from './GenericChartVisualization';

export default class PieSeriesGenericChartVisualization extends GenericChartVisualization {

    getPlotOptionsSection(): any {

        const section = super.getPlotOptionsSection();

        return {
            ...section,
            pie: {
                ...section.pie,
                dataLabels: {
                    style: {
                        fontWeight: 'normal',
                        textShadow: 'none',
                    }
                },
                slicedOffset: 0,
                events: {
                },
                point: {
                    events: {
                        legendItemClick(event: any) {
                            event.preventDefault();
                            const point : any = this;
                            const data = point.series.chart.series.map((item: any) => item.data);
                            const dataArray = data.flat();
                            dataArray.forEach((dataItem: any) => {
                                if (dataItem.name === point.name) {
                                    dataItem.setVisible(!dataItem.visible);
                                }
                            });
                        }
                    }
                }
            }
        }
    }
}
